export default "__VITE_ASSET__1d4c692b__"